import { AnyAction } from 'redux'

interface FilterRoleNameState {
  filterValues: any
}

const noFilterValues: FilterRoleNameState = {
  filterValues: {},
}

const filterValues = (state = noFilterValues, action: AnyAction) => {
  switch (action.type) {
    case 'SET_FILTER_VALUES':
      
      const newState = {
        filterValues: action.filterValues,
      }

      return {
        ...state,
        ...newState,
      }

    default:
      return state
  }
}

export default filterValues
